export const titles = [
  { title: 'Name', maxWidth: 150 },
  { title: 'API key', maxWidth: 150 },
  { title: 'Created by', maxWidth: 150 },
  { title: 'Date', maxWidth: 70 },
  { title: '', maxWidth: 20 },
]
